import { render, staticRenderFns } from "./RecipientEdit.vue?vue&type=template&id=3460b7da"
import script from "./RecipientEdit.vue?vue&type=script&lang=js"
export * from "./RecipientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports